import { useState } from "react";
import Markdown from "react-markdown";

import axios from "../../../../interceptors/axiosInstance";
import { config } from "../../../../config";
import "./ChatWidget.css";

const ChatWidget = ({
  isOpen,
  toggleChat,
  inputs,
  chartData,
  npvData,
  handleToolCallResponse,
  extraContext,
}) => {
  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [thinking, setThinking] = useState(false);

  const sendMessage = async () => {
    if (!input.trim()) return;

    const newMessage = { role: "user", content: input };
    const updatedMessages = [...messages, newMessage];
    setMessages(updatedMessages);
    setInput("");

    try {
      setThinking(true);
      const response = await axios.post(`${config.BASE_URL}/api/ppa/chat`, {
        messages: updatedMessages,
        apiResponse: { inputs, chartData, npvData },
        extraContext,
      });
      setThinking(false);
      if (response.data?.update) {
        handleToolCallResponse(response.data?.newData);
      }
      setMessages([...response?.data?.messages]);
    } catch (err) {
      setThinking(false);
      console.log("Error ****", err);
      setMessages([
        ...updatedMessages,
        { role: "assistant", content: "Error connecting to the server" },
      ]);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") sendMessage();
  };

  return (
    <div className="chat-widget">
      {isOpen && (
        <div className="chat-window">
          <div className="chat-header">
            <div className="heading">
              <img
                className="ai-icon"
                src={"/icons/ai-chat.svg"}
                alt="AI icon"
              />
              <span>Chat With Result</span>
            </div>
            <button onClick={toggleChat} className="close-btn">
              X
            </button>
          </div>
          <div className="chat-body">
            {messages.length === 0 && (
              <div className="placeholder">Ask me anything...</div>
            )}
            {messages
              .filter(
                (msg) =>
                  msg.role === "user" ||
                  (msg.role === "assistant" && msg.content)
              )
              .map((msg, i) => (
                <div className="chat-msg-container" key={i}>
                  {msg.role === "user" ? (
                    <div className="user">U</div>
                  ) : (
                    <div className="user">
                      <img
                        className="ai-icon"
                        src={"/icons/ai-chat.svg"}
                        alt="AI icon"
                      />
                    </div>
                  )}
                  <div className="chat-msg">
                    <Markdown>{msg.content}</Markdown>
                  </div>
                </div>
              ))}
            {thinking && <div className="placeholder">Thinking...</div>}
          </div>
          <div className="chat-input-area">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={handleKeyDown}
              placeholder="Ask a question"
            />
            <img
              className="send-icon"
              src={"/icons/send.svg"}
              alt="Send Button"
              role="button"
              title="Send"
              onClick={sendMessage}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ChatWidget;
